import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ReviewService } from 'src/app/services/common/review.service';

@Component({
  selector: 'app-review-documents-model',
  templateUrl: './review-documents-model.component.html',
  styleUrls: ['./review-documents-model.component.scss']
})
export class ReviewDocumentsModelComponent implements OnInit {

  @ViewChild('SelectAll') input: ElementRef<HTMLInputElement>;
  @Input() public Content: any;
  content: any;
  allFiles: any[];
  selectedFiles: any[]= [];
  selectedAllItems: boolean = false;
  isAppchecked: boolean = false;
  searchForm: UntypedFormGroup;
  searchFilter: string="";
  previouslySelectedFiles: any[]= [];
  DocType: string;
  FilesListSelect: any [] = [];
  FilesListReference: any [] = [];
  ApplicationId: string;
  Module: string;
  ApplicationCode:string;
  appAsDocExist: boolean = false;
  isChecked: boolean = false
  atleastonedocExist: boolean = false;
  referencefiles: any[]=[];
  constructor(
    public modalRef: NgbActiveModal,    
    private reviewService: ReviewService
  ) { 

  }

  ngOnInit( ) { 
    if (this.Content !== null) {
      this.isAppchecked = false;
      this.ApplicationId = this.Content.ApplicationId;
      this.ApplicationCode = this.Content.ApplicationCode;
      this.Module = this.Content.module;
      this.DocType = this.Content.DocType;

      this.GetDocumentsAndApplication();
      //this.allFiles = this.Content.fileList;
      if(this.Content.SelectedFiles)
      {
        this.previouslySelectedFiles = this.Content.SelectedFiles;
        if(this.DocType!="Reference"){
          let appFile=this.previouslySelectedFiles.some(f => f.isSelectedApplication === true);
          if(appFile)
            this.isAppchecked = true;
        }
      }
      else{
        this.previouslySelectedFiles =[];
      }
    }   

    this.searchForm = new UntypedFormGroup({
      searchFilter: new UntypedFormControl('')
    });
  }

  
  get form() {
    return this.searchForm.controls;
  }

  GetDocumentsAndApplication() {

    this.reviewService.GetDocuments("api/Review/GetDocuments?ApplicationID=" + this.ApplicationId + "&Module=" + this.Module).subscribe(result => {
      if (result) {            

        if (this.DocType == "Select") {
          this.FilesListSelect = result["GetDocuments"];
          this.allFiles = this.FilesListSelect.filter(x=> x.FileName.match(/\.([^\.]+)$/)[1] == "docx" ||  x.FileName.match(/\.([^\.]+)$/)[1] == "doc" ||  x.FileName.match(/\.([^\.]+)$/)[1] == "ppt" ||  x.FileName.match(/\.([^\.]+)$/)[1] == "pptx");;
        } else{
          this.FilesListReference = result["GetReferenceDocuments"];
          this.allFiles = this.FilesListReference;
        }      

        this.allFiles.forEach((doc) => {
          this.previouslySelectedFiles.forEach((sdoc) => {
            if (sdoc.FileID == doc.FileID)
              this.isChecked = doc.isSelected = true;
          });          
        });

        let selectedRecords = this.allFiles.filter((record) => record.isSelected);  
        if(selectedRecords.length >=1){          
            selectedRecords.forEach(ele => {
             let index = this.allFiles.findIndex(x=> x.FileID == ele.FileID);
             this.allFiles.splice(index, 1);
            });         
        } 

        if (this.Content.Heading != "Add" ) {
          if(!this.Content.isReviewDocfromApp)
          {  
            //  if(this.Content.SelectedFiles.length > 0)this.atleastonedocExist = true; // to disable Application when inner doc/ feature docs selected
            this.isAppchecked = false;
            this.appAsDocExist = false;
          }
          else{  //application details in as word DOC is existed 
            this.atleastonedocExist = false;
           
            this.appAsDocExist = true;
          }
          
        }
        if(this.DocType=="Reference")
        { 
          this.isAppchecked = false;
        }

        if (this.allFiles?.length >= 1) {
          this.selectedAllItems = selectedRecords?.length == this.allFiles?.length ? true : false; 
        }  
      }
    });
  }

  selecteddoc(event: any, doc: any): void {
    let isChecked: boolean = event.target.checked;
    doc.IsSelected = isChecked;
    let ext = doc.FileName.match(/\.([^\.]+)$/)[1];
    doc.FileExt = ext;
    let selectedRecords = this.allFiles.filter((record) => record.IsSelected) ?? [];   
    this.selectedAllItems = selectedRecords?.length == this.allFiles?.length ? true : false;   
  }


  selectAll(event: any): void {
    this.selectedAllItems = true;
    this.isAppchecked = false;
    //this.atleastonedocExist = true;
    this.isChecked = event.target.checked;
      this.allFiles.forEach((docs) => {
        const docIndex = this.allFiles.findIndex((docSelected) => docSelected.FileID === docs.FileID);
      if (docIndex != -1) {
        docs.isSelected = this.isChecked;
          let ext = docs.FileName.match(/\.([^\.]+)$/)[1];
          docs.FileExt = ext;
          docs.Status = "Add";
          const listIndex = this.selectedFiles.findIndex((selectedDoc) => selectedDoc.FileID === docs.FileID);
        if (this.isChecked && listIndex == -1) {
            this.selectedFiles.push(docs);
        } else if (!this.isChecked) {
            this.selectedFiles.splice(listIndex, 1);
          }
        }
      });
      
      this.atleastonedocExist = this.selectedFiles.length > 0;

      // if(this.allFiles.length == 0){
      //   this.isAppchecked = true;
      // }
  } 
  


collectSelectedDoc(event: any, type: any, doc: any) {
  if (type == "app") {
    this.isAppchecked = event.target.checked;
    this.isChecked = false;
    //this.selectedAllItems = event.target.checked;
  } else {
    this.isAppchecked = false;
    this.isChecked = event.target.checked;
    doc.isSelected = this.isChecked;

    let ext = doc.FileName.match(/\.([^\.]+)$/)?.[1];
    doc.FileExt = ext;
    doc.Status = "Add";

    if (!this.isChecked) {
      let prodIndex = this.selectedFiles.findIndex((selectedDoc: any) => selectedDoc.FileID == doc.FileID);
      if (prodIndex !== -1) this.selectedFiles.splice(prodIndex, 1);
    } else {
      this.selectedFiles.push(doc);
    }

    this.atleastonedocExist = this.selectedFiles.length > 0;
    const selectedCount = this.allFiles.filter(f => f.isSelected).length;
    this.selectedAllItems=false;
    if(selectedCount === this.allFiles.length)
    {
      this.selectedAllItems = true;
    }
   
  }
}

  save() {

    let obj = new Object()
    obj['isAppchecked'] = this.isAppchecked;
    if (this.isAppchecked) {
      let body = new Object()
      body['ApplicationId'] = this.ApplicationId
      body['ApplicationCode'] = this.ApplicationCode
      body['Module'] = this.Module
      this.reviewService.DocApplication("api/ISTFileAttachments/Applicationfile", body).subscribe(result => {
        if (result) {
          this.selectedFiles.push(result);
          obj['selectedfiles'] = this.selectedFiles;
         // obj['referenceFiles'] = this.referencefiles;
          this.modalRef.close(obj);
        }
      });
    } else {
      obj['selectedfiles'] = this.selectedFiles;
      this.modalRef.close(obj);
    }

  }

  close(){
    if(this.allFiles != undefined && this.allFiles != null){
      this.allFiles.forEach(element => {
            let file = this.previouslySelectedFiles.find(x=> x.FileID == element.FileID);
            if(file != null ){
              file.isSelected = true;
            } else{
              element.isSelected = false;
            }
      });
      this.modalRef.dismiss(this.previouslySelectedFiles);
    }else{
      this.modalRef.dismiss();
    }
    
  }
}
